import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import { formatReceiptNumber, Receipt } from "../../models/receipt";

interface ReceiptDeleteModalProps {
  show: boolean;
  receipt?: Receipt;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const ReceiptDeleteModal: React.FC<ReceiptDeleteModalProps> = ({
  show,
  receipt,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = receipt
    ? `Está seguro de que quiere eliminar el recibo Nº ${formatReceiptNumber(
        receipt
      )}`
    : "";

  const onDeleteClick = async () => {
    if (receipt !== undefined) {
      setSubmitting(true);
      const requestStatus = await deleteItem(
        `/receipts/${receipt.id}/`,
        receipt
      );

      if (requestStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (requestStatus.detail !== undefined) {
          message = requestStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default ReceiptDeleteModal;
